module.exports = __webpack_public_path__ + "static/img/notice_cinematographe.450aab6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/notice_cinematographe.jpg
// module id = 31
// module chunks = 0